export var SpecialDayTypeEnum;
(function (SpecialDayTypeEnum) {
    SpecialDayTypeEnum["CLOSED_DAY"] = "CLOSED_DAY";
    SpecialDayTypeEnum["SHORT_DAY"] = "SHORT_DAY";
})(SpecialDayTypeEnum || (SpecialDayTypeEnum = {}));
//# sourceMappingURL=special-day-type.enum.js.map